import React, {Component, lazy, Suspense} from 'react';
import './App.css';
import {Route, Switch, withRouter} from 'react-router-dom';
import InnerHTML from 'dangerously-set-html-content';

import {getCurrentUser} from '../util/APIUtils';
import {ACCESS_TOKEN} from '../constants';
import '../util/explorer_support';

import AppHeader from '../common/AppHeader';
import NotFound from '../common/NotFound';
import LoadingIndicator from '../common/LoadingIndicator';
import {Col, Layout, notification, Spin} from 'antd';
import UnderDevelopment from "../common/UnderDevelopment";
import FinancialSealHome from "../page/token/home/FinancialSealHome";
import FinancialSealApps from "../page/token/apps/FinancialSealApps";
import TenantList from "../page/tenant/tenant/TenantList";
import ApartmentList from "../page/tenant/apartment/ApartmentList";
import ThreeDSecure from "../page/payment/topay/ThreeDSecure";

const ToPay = lazy(() => import( '../page/payment/topay/ToPay'));
const Home = lazy(() => import( '../page/payment/home/Home'));
const Menu = lazy(() => import( '../page/common/menu/Menu'));
const MyPayment = lazy(() => import( '../page/payment/list/PaymentList'));
const Profile = lazy(() => import( '../page/common/profile/Profile'));
const Login = lazy(() => import( '../page/common/login/Login'));
const LoginAljabe = lazy(() => import( '../page/common/aljabe/LoginAljabe'));
const HizliTahsilat = lazy(() => import( '../page/payment/hizlitahsilat/HizliTahsilat'));
const TenantHome = lazy(() => import( '../page/tenant/home/TenantHome'));

const {Content} = Layout;

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: null,
            isAuthenticated: false,
            isLoading: false,
            rawHtml:null,
            show3D:false,
            threeDResult:null,
            language:"en"
        };
        this.close3D = this.close3D.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.loadCurrentUser = this.loadCurrentUser.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.checkRouter = this.checkRouter.bind(this);
        this.show3DModal = this.show3DModal.bind(this);
        this.handleThreeDMessage = this.handleThreeDMessage.bind(this);

        notification.config({
            placement: 'topRight',
            top: 70,
            duration: 3,
        });
    }

    componentDidMount() {
        if(window.top !== window.self){
            const match = window.location.pathname.match(/external\/([^/?]+)/);
            const params = new URLSearchParams(window.location.search);
            try {
                window.top.postMessage({
                    type: 'THREE_DS_COMPLETE',
                    referenceCode: match ? match[1] : null,
                    transactionType: params.get('transaction_type'),
                    paymentStatus: params.get('payment_status')
                }, window.location.origin);
            } catch (e) {}
            return;
        }

        window.addEventListener('message', this.handleThreeDMessage);
        if(window.location.href === "https://hizlitahsilat.net/payment/" || window.location.href === "https://www.hizlitahsilat.net/payment/"){
            this.props.history.push("/hizlitahsilat");
        }else{
            if(!this.checkRouter())
                this.loadCurrentUser();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.handleThreeDMessage);
    }

    handleThreeDMessage(event) {
        if(event.data && event.data.type === 'THREE_DS_COMPLETE'){
            this.setState({rawHtml:null, show3D:false, threeDResult:event.data});
        }
    }

    checkRouter(){
        let result = false;
        const checkList = [
            "/external",
            "/hizlitahsilat",
            "to-pay-external",
            "paymentPage",
            "query-payment",
        ]
        checkList.forEach(
            element => {
                if(window.location.href.includes(element))
                    result = true;
            }
        )
        return result;
    }

    loadCurrentUser() {
        this.setState({isLoading: true});
        getCurrentUser()
          .then(response => {
              console.log(response.data)
              this.setState({
                  currentUser: response.data,
                  isAuthenticated: true,
                  isLoading: false,
              });
          }).catch(error => {
            this.setState({isLoading: false},()=> {this.props.history.push("/login")});
        });
    }

    handleLogout(redirectTo = "/login", notificationType = "success", description = "Başarılı şekilde çıkış yaptınız") {
        localStorage.removeItem(ACCESS_TOKEN);
        this.setState({
            currentUser: null,
            isAuthenticated: false
        });
        this.props.history.push(redirectTo);
        notification[notificationType]({
            message: 'Bilgilendirme',
            description: description,
        });
    }

    handleLogin() {
        notification.success({
            message: 'Başarılı',
            description: "Başarıyla giriş yaptınız.",
        });
        this.loadCurrentUser();
        this.props.history.push("/");
    }

    show3DModal(rawHtml) {
        this.setState({rawHtml,show3D:true});
    }

    close3D(){
        this.setState({rawHtml:null,show3D:false});
    }

    render() {
        if(this.state.show3D && this.state.rawHtml){
            return <ThreeDSecure threeDHtml={this.state.rawHtml} close3D={this.close3D} show3D={this.state.show3D} />
        }

        if (this.state.isLoading) {
            return <LoadingIndicator/>
        }

        return (
            <Layout className="app-container">
                {this.props.location.pathname !=='/' && this.props.location.pathname!=='/under-development' && this.state.currentUser &&
                <AppHeader isAuthenticated={this.state.isAuthenticated}
                           currentUser={this.state.currentUser}
                           language={this.state.language}
                           onChangeLanguage={(lang)=>this.setState({language:lang})}
                           onLogout={this.handleLogout}/>
                }
                <Content className="app-content">
                    <div className="container">
                        <Suspense fallback={
                            <Col span={24} style={{paddingTop:160, textAlign:"center"}}>
                                <Spin size="small" />
                            </Col>
                        }>
                        <Switch>
                            <Route exact path="/" render={(props) => <Menu currentUser={this.state.currentUser} onLogout={this.handleLogout} {...props} />}/>
                            <Route path="/home" render={(props) => <Home currentUser={this.state.currentUser} {...props} />}/>
                            <Route path="/login" render={(props) => window.location.href.indexOf('aljabe') > -1 ? <LoginAljabe onLogin={this.handleLogin} {...props} />: <Login onLogin={this.handleLogin} {...props} />}/>
                            <Route path="/external/:uuid" render={(props) => <ToPay type="external" show3D={this.show3DModal} threeDResult={this.state.threeDResult} {...props} />}/>
                            <Route path="/hizlitahsilat" render={(props) => <HizliTahsilat currentUser={this.state.currentUser} {...props} />}/>
                            <Route path="/paymentPage/:uuid" render={(props) => <ToPay type="external" {...props} />}/>
                            <Route path="/to-pay-external" render={(props) => <ToPay type="external" enabledOther={true} currentUser={this.state.currentUser} {...props} />}/>
                            <Route path="/query-payment" render={(props) => <MyPayment type="external" currentUser={this.state.currentUser} {...props} />}/>
                            <Route path="/my-payment" render={(props) => <MyPayment type="internal" currentUser={this.state.currentUser} {...props} />}/>
                            <Route path="/auth/:username" render={(props) => <Profile isAuthenticated={this.state.isAuthenticated} currentUser={this.state.currentUser} {...props}  />}/>
                            <Route path="/financial-seal-home" render={(props) => <FinancialSealHome currentUser={this.state.currentUser} {...props} />}/>
                            <Route path="/financial-seal-apps" render={(props) => <FinancialSealApps currentUser={this.state.currentUser} {...props} />}/>
                            <Route path="/tenant-list" render={(props) => <TenantList currentUser={this.state.currentUser} {...props} lang={this.state.language}/>}/>
                            <Route path="/apartment-list" render={(props) => <ApartmentList currentUser={this.state.currentUser} {...props} lang={this.state.language}/>}/>
                            <Route path="/under-development" render={(props) => <UnderDevelopment {...props}  />}/>
                            <Route component={NotFound}/>
                        </Switch>
                        </Suspense>
                    </div>
                </Content>
            </Layout>
        );
    }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/app/App.js